import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { setTimeout } from 'timers';

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.scss']
})
export class DownloadFileComponent implements OnInit {

  fileAtch: any
  km: any
  fileId: any

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute
    ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    this.activatedRoute.queryParams.subscribe(params => {
      this.fileId = params['file'];
    });

    await this.getFileFromAPI()

  }

  async getFileFromAPI() {
    this.fileAtch = await this.apiService.get("crmservice", "annotation", "annotationid=" + this.fileId)

    if(this.fileAtch == null){
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("เกิดข้อผิดพลาดกรูณาติดต่อเจ้าหน้าที")
      return
    }

    this.downloadBase64File(this.fileAtch.mimetype, this.fileAtch.documentbody, this.fileAtch.filename)

  }

  downloadBase64File(contentType: any, base64Data: any, fileName: any) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();

    this.util.ShowWaiting(false)
    setTimeout(() => {
      window.close()
    }, 1200);
    
  }
}



// WEBPACK FOOTER //
// ./src/app/download-file/download-file.component.ts